import { useEffect } from 'react'
import HeadMeta from 'components/common/HeadMeta'
import JsonLd, { applicationDevelopmentPageMeta, applicationDevelopmentSchema } from 'components/common/schema'
import Template from 'components/services/application-development'

const Application_development: React.FC = () => {
  useEffect(() => {
    document.querySelector('body').classList.remove('non-chat')
  }, [])
  return (
    <>
      <HeadMeta {...applicationDevelopmentPageMeta} />
      <JsonLd data={applicationDevelopmentSchema} />
      <Template />
    </>
  )
}

export default Application_development
